import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import FailureScreen from '../../../Shared/FailureScreen/FailureScreen';
import {resetBlock} from '../saleBlockSlice';
import { clearStateHistoryAction } from '../../../../utilities/stateHistory/stateHistorySlice';

const ErrorPage = (props) => {
  
  useEffect(() => {
    return () => {
      props.resetBlock();
      props.clearStateHistoryAction();
      var path = window.location.pathname;
      window.location.replace(path);
    };
  }, []);

  //page params
  let isDisplayFooter = false;
  let btnText = 'המשך';
  let currentPageFunction = null;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';

  let currentPageView = <FailureScreen errorId={props.error.id} onclick={handleErrorPageClose} />;

  function handleErrorPageClose() {
    props.resetBlock();
    var path = window.location.pathname;
    window.location.replace(path);
  }

  return (
    <div className='slideAnimation'>
      <div className='sale-page-content'>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    error: state.saleBlock.error,
  };
};

const mapDispatchToProps = {resetBlock, clearStateHistoryAction};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
